<template lang="pug">
  .support-kb-diff(v-loading="loading")
    .support-page-header
      el-button(size="small" @click="goBack") ← Volver al editor
      h1 Comparar: {{ articleTitle }}

    el-row(:gutter="16" v-if="data")
      el-col(:span="12")
        h3 Original (.md)
        pre.support-diff-pane {{ originalContent || '(sin original)' }}
      el-col(:span="12")
        h3 Versión actual (DB)
        pre.support-diff-pane {{ currentContent || '(no se pudo leer)' }}

    .support-diff-actions(v-if="data")
      el-button(@click="goBack") ← Volver al editor
      el-button(type="primary" @click="restore" :loading="restoring") ↺ Restaurar al original
</template>

<script>
import supportService from "@/services/support";

/**
 * @component KBDiffView
 * @description Comparación side-by-side entre el snapshot del .md original
 *              y el contenido actual del artículo (Fase 2 — UC-REG-098).
 *              No renderiza diff coloreado (sin lib `diff` en backend) —
 *              muestra ambos textos lado a lado para inspección visual.
 *              Para diff inline coloreado, sumar dep `diff` en V2.
 * @example <KBDiffView />
 */
export default {
  name: "KBDiffView",
  data() {
    return {
      loading: false,
      restoring: false,
      data: null,
      articleTitle: "",
    };
  },
  computed: {
    originalContent() {
      return this.data && this.data.source && this.data.source.originalContent;
    },
    currentContent() {
      return this.data && this.data.drift && this.data.drift.currentContent;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    /**
     * @description Carga el artículo + source/drift.
     */
    async load() {
      this.loading = true;
      try {
        const [article, source] = await Promise.all([
          supportService.getArticle(this.$route.params.id),
          supportService.getArticleSource(this.$route.params.id),
        ]);
        this.articleTitle = article.titulo;
        this.data = source;
      } catch (err) {
        this.$message.error("No pude cargar el diff.");
      } finally {
        this.loading = false;
      }
    },
    /**
     * @description Restaurar contenido al snapshot.
     */
    async restore() {
      try {
        await this.$confirm(
          "Pisar el contenido actual con el original. ¿Seguir?",
          "Confirmar"
        );
      } catch (e) {
        return;
      }
      this.restoring = true;
      try {
        await supportService.restoreArticle(this.$route.params.id);
        this.$message.success("Restaurado.");
        this.$router.push({
          name: "support-kb-edit",
          params: { id: this.$route.params.id },
        });
      } catch (err) {
        this.$message.error("No pude restaurar.");
      } finally {
        this.restoring = false;
      }
    },
    goBack() {
      this.$router.push({
        name: "support-kb-edit",
        params: { id: this.$route.params.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.support-page-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  h1 {
    margin: 0;
    font-size: 18px;
    color: #002d5e;
    flex: 1;
  }
}
.support-diff-pane {
  background: #f7f9fb;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 12px;
  font-family: "Fira Code", monospace;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 600px;
  overflow-y: auto;
}
.support-diff-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>
